import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import Draggable from 'react-draggable';
import { Resizable } from 're-resizable';
import { useDispatch } from 'react-redux';
import { deleteCoordinate, updateCoordinate } from '../../../store/reducers/pdfeditor/pdfCoordinatesSlice';
import { selectVariable, updateBoxSize } from '../../../store/reducers/pdfeditor/toolsModificationSlice';
import ToolBarText from './ToolbarText';
import { toast } from 'react-toastify';

function InputBox({ coordinate, scale, dimensions, isSelected, onSelect,setSelectedBoxId }) {
  const nodeRef = useRef(null);
  const dispatch = useDispatch();

  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    prex: parseInt(coordinate['x-coordinate']) * scale,
    prey: parseInt(coordinate['y-coordinate']) * scale,
  });
  const [boxSize, setBoxSize] = useState({
    width: coordinate.width,
    height: coordinate.height,
  });
  const [inputValue, setInputValue] = useState(coordinate.fieldValue);
  // const textAreaRef = useRef(null);

  // useEffect(() => {
  //   if (textAreaRef.current) {
  //     // Set focus on the textarea
  //     textAreaRef.current.focus();

  //     // Move the cursor to the end of the text
  //     textAreaRef.current.setSelectionRange(
  //       textAreaRef.current.value.length,
  //       textAreaRef.current.value.length
  //     );
  //   }
  // }, []); // Re-run when inputValue changes
  // const autoFocustextArea = () => {
  //   if (textAreaRef.current) {
  //     // Set focus on the textarea
  //     textAreaRef.current.focus();

  //     // Move the cursor to the end of the text
  //     textAreaRef.current.setSelectionRange(
  //       textAreaRef.current.value.length,
  //       textAreaRef.current.value.length
  //     );
  //   }
  // }

  useEffect(() => {
    setPosition({
      x: 0,
      y: 0,
      prex: parseInt(coordinate['x-coordinate']) * scale,
      prey: parseInt(coordinate['y-coordinate']) * scale,
    });
  }, [coordinate, scale]);

  useEffect(() => {
    if (isSelected) {
      handleSelectBox(coordinate);
    }
  }, [isSelected]);

  const handleInput = (value) => {
    setInputValue(value);
    const id = coordinate.id;
    const newValue = {
      value: value,
      fieldValue: value,
      data_type: 'text',
      fontSize: coordinate.fontSize,
      fontFamily: coordinate.fontFamily,
      fontSpace: coordinate.fontSpace,
      height: coordinate.height,
    };
    dispatch(updateCoordinate({ id, newValue }));
    dispatch(
      selectVariable({
        ...coordinate,
        variableName: value,
        ...newValue,
      })
    );
  };

  const handleResizeStop = (e, direction, ref, d) => {
    setBoxSize({
      width: boxSize.width + d.width,
      height: boxSize.height + d.height,
    });
    dispatch(
      updateBoxSize({
        width: boxSize.width + d.width,
        height: boxSize.height + d.height,
      })
    );
    dispatch(
      updateCoordinate({
        id: coordinate.id,
        newValue: {
          ...coordinate,
          width: boxSize.width + d.width,
          height: boxSize.height + d.height,
        },
      })
    );
  };

  const handleSelectBox = (coordinates) => {
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        boldVal: coordinates.boldVal,
        italicVal: coordinates.italicVal,
        data_type: coordinate.data_type,
        variableName: coordinates.value,
        fontFamily: coordinates.fontFamily,
        fontSpace: coordinates.fontSpace,
      })
    );
    dispatch(
      updateCoordinate({
        id: coordinate.id,
        newValue: {
          boldVal: coordinates.boldVal,
          italicVal: coordinates.italicVal,
        },
      })
    );
  };

  const handleStop = (e, data) => {
    const updatedCoordinates = {
      'x-coordinate': (position.prex + data.x) / scale,
      'y-coordinate': (position.prey + data.y) / scale,
    };
    const { width, height } = boxSize || {};
    const xCoord = updatedCoordinates['x-coordinate'] * scale;
    const yCoord = updatedCoordinates['y-coordinate'] * scale;

    if (
      dimensions.width < xCoord + width ||
      dimensions.width < 0 ||
      xCoord < 0 ||
      yCoord < 0 ||
      dimensions.height < yCoord + height
    ) {
      toast.error(
        'Coordinate should stay within the PDF previewer area when dragging.'
      );
      setPosition({
        x: 0,
        y: 0,
        prex: parseInt(coordinate['x-coordinate']) * scale,
        prey: parseInt(coordinate['y-coordinate']) * scale,
      });
    } else {
      dispatch(
        updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
      );
    }
    onSelect(); // Ensure box is selected on drag stop
  };

  return (
    <>
      {isSelected && (
        <ToolBarText
          style={{ position: 'absolute', zIndex: 12 }}
          settedFontSize={coordinate.fontSize}
          settedFontSpace={coordinate.fontSpace}
          settedBoxHeight={coordinate.height}
          settedBoxWidth={coordinate.width}
          position={position}
          coordinate={coordinate}
          setSelectedBoxId={setSelectedBoxId}
        />
      )}

      {isSelected ? (
        <Resizable
          onMouseEnter={() => onSelect()}
          onMouseLeave={() => onSelect()}
          onClick={() => onSelect()}
          style={{
            position: 'absolute',
            left: `${position.prex}px`,
            top: `${position.prey}px`,
            height: `${coordinate.height}px !important`,
            width: `${coordinate.width}px !important`,
            textAlign: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            transition: 'all 0.1s ease-out',
            fontSize: '15px',
            background: 'none',
            outline: 'none',
            borderRadius: '3px',
            border: '1px dashed #000000',
            zIndex:3,
          }}
          defaultSize={{
            width: coordinate.width,
            height: coordinate.height,
          }}
          onResizeStart={() => {}}
          onResizeStop={(e, direction, ref, d) => handleResizeStop(e, direction, ref, d)}
        >
          <textarea
            // ref={textAreaRef}
            style={{
              background: 'none',
              fontSize: coordinate.fontSize,
              letterSpacing: coordinate.fontSpace,
              fontWeight: `${coordinate.boldVal ? 'bold' : 'normal'}`,
              fontStyle: `${coordinate.italicVal ? 'italic' : 'normal'}`,
              color: `${coordinate.color ? coordinate.color : 'black'}`,
              position: 'relative',
              fontFamily: coordinate.fontFamily,
              resize: 'none',
              overflow: 'hidden',
              whiteSpace: 'pre-wrap',
              outline: 'none',
              height: '100%',
              width: '100%',
              border: 'none',
            }}
            autoFocus={true}
            value={inputValue}
            onChange={(e) => handleInput(e.target.value)}
            type="text"
            placeholder="Enter Text"
          />
        </Resizable>
      ) : (
        <Draggable
          nodeRef={nodeRef}
          position={position}
          // onStart={() => onSelect()}
          onStop={(e, data) => handleStop(e, data)}
          // onMouseEnter={() => onSelect()}
          // onMouseLeave={() => onSelect()}
          style={{
            height: `${coordinate.height} !important`,
            width: `${coordinate.width} !important`,
            zIndex: 2,
          }}
          onClick={() => {onSelect();}}
        >
          <Box
            ref={nodeRef}
            style={{
              position: 'absolute',
              left: `${position.prex}px`,
              top: `${position.prey}px`,
              border: '1px solid #000',
              cursor: 'move',
              height: coordinate.height,
              width: coordinate.width,
              textAlign: 'center',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              transition: 'all 0.1s ease-out',
              display: 'flex',
              alignItem: 'center',
              justifyContent: 'flex-start',
              zIndex: 3,
            }}
          >
            <Typography
              sx={{
                fontSize: coordinate.fontSize,
                letterSpacing: coordinate.fontSpace,
                fontWeight: `${coordinate.boldVal ? 'bold' : 'normal'}`,
                fontStyle: `${coordinate.italicVal ? 'italic' : 'normal'}`,
                color: `${coordinate.color ? coordinate.color : '#000'}`,
                zIndex: 2,
                fontFamily: coordinate.fontFamily,
              }}
            >
              {inputValue || coordinate.fieldValue}
            </Typography>
          </Box>
        </Draggable>
      )}
    </>
  );
}

export default InputBox;
